import { AssessmentTokenService } from '../../shared/services/assessment-token.service';
import { Role } from '../../shared/models/role';
import { AlertService } from '../../shared/services/alert.service';
import { OnInit, OnDestroy } from '@angular/core';
import { AssessmentService } from '../../shared/services/assessment.service';
import { DacConfig } from "../../shared/services/dac-config.service";
import { AuthService } from 'app/login/services/auth.service';
var AssessmentListComponent = /** @class */ (function () {
    function AssessmentListComponent(_assessmentService, alertService, dacConfig, authService, assessmentTokenService) {
        var _this = this;
        this._assessmentService = _assessmentService;
        this.alertService = alertService;
        this.dacConfig = dacConfig;
        this.authService = authService;
        this.assessmentTokenService = assessmentTokenService;
        this._assessments = [];
        this.hasLoadedAssessments = false;
        this._userRole = Role.UnAuthenticated;
        this._userSubscription = this.authService.getLoginState().subscribe(function (loginState) {
            if (loginState.user) {
                _this._userRole = loginState.user.role;
            }
            else {
                _this._userRole = Role.UnAuthenticated;
            }
        });
    }
    AssessmentListComponent.prototype.ngOnDestroy = function () {
        this._userSubscription.unsubscribe();
    };
    Object.defineProperty(AssessmentListComponent.prototype, "Assessments", {
        get: function () {
            return this._assessments;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentListComponent.prototype, "canManageAssessments", {
        get: function () {
            return this.dacConfig.isFeatureEnabled("assessments.manage");
        },
        enumerable: true,
        configurable: true
    });
    AssessmentListComponent.prototype.canEdit = function (assessment) {
        if (this._userRole == Role.SuperUser) {
            return true;
        }
        else if (this._userRole == Role.Admin) {
            return !assessment.isPublic;
        }
        return false;
    };
    AssessmentListComponent.prototype.getTokens = function (assessment) {
        return this.assessmentTokenService.getRemainingTokens(assessment);
    };
    Object.defineProperty(AssessmentListComponent.prototype, "tokensEnabled", {
        get: function () {
            return this.assessmentTokenService.isTokensEnabled();
        },
        enumerable: true,
        configurable: true
    });
    AssessmentListComponent.prototype.ngOnInit = function () {
        var _this = this;
        Promise.all([
            this._assessmentService.getAssessmentList(),
            this.assessmentTokenService.loadAssessmentTokens()
        ])
            .then(function (results) {
            var assessmentList = results[0];
            _this._assessments = assessmentList;
            _this.hasLoadedAssessments = true;
        })
            .catch(function (error) {
            _this.alertService.error("Failed to load assessments from server");
            console.error(error);
            _this.hasLoadedAssessments = true;
        });
    };
    return AssessmentListComponent;
}());
export { AssessmentListComponent };



// WEBPACK FOOTER //
// ./src/app/admin/assessment-list/assessment-list.component.ts.pre-build-optimizer.js